import React, { forwardRef, useId } from 'react'
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Spacer
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import SearchResultItem from './SearchResultItem'

const SearchResults = ({ results = [], level = 0 }) => {
  const prefix = useId()
  if (!results || results.length === 0) {
    return (
      <Box
        backgroundColor="brand.lightGray"
        fontSize="14px"
        p="8px"
        borderRadius="8px">
        0 results found.
      </Box>
    )
  }

  return (
    <Accordion
      allowMultiple
      m={0}
      p={0}
      position="relative"
      border="none"
      defaultIndex={[0]}>
      <>
        {results.map((result, index) => {
          return (
            (result.children && (
              <SearchResultsAccordion
                key={index}
                result={result}
                variant={level}
              />
            )) || (
              <SearchResultItem
                key={prefix + index}
                result={result}
              />
            )
          )
        })}
      </>
    </Accordion>
  )
}

SearchResults.propTypes = {
  results: PropTypes.any,
  isChild: PropTypes.bool,
}

const SearchResultsAccordion = forwardRef(({ result = false, level }, ref) => {
  let amountOfResults = 0
  result.children.forEach(item => {
    if (item.children) {
      item.children.forEach(() => amountOfResults++)
    }
  })
  return (
    <AccordionItem
      border="none"
      ref={ref}>
      <AccordionButton pl={0}>
        <Heading
          size={level === 0 ? 'sm' : 'xs'}
          fontWeight={level === 0 ? '500' : 'bold'}>
          {result.title} {result.children && `(${result.children.length})`}
        </Heading>
        <Spacer />
        <AccordionIcon />
      </AccordionButton>
      <AccordionPanel
        p={1}
        pl={0}
        pr={0}>
        <SearchResults
          results={result.children}
          isChild
          variant={level + 1}
        />
      </AccordionPanel>
    </AccordionItem>
  )
})

SearchResultsAccordion.propTypes = {
  result: PropTypes.any,
}
export default SearchResults
